// extracted by mini-css-extract-plugin
export default {"container":"SiteHeading_container__Pstaf"};